var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"frame",attrs:{"src":"https://quantumjs-9e2ff.web.app","title":"JsQuantum Simulator"}})
}
var staticRenderFns = []

export { render, staticRenderFns }